<template>
	<div v-if="isUserAllowedInLevel5or6" class="flex-grow flex flex-col py-5 px-8">
		<slot></slot>
	</div>
	<Forbidden v-else />
</template>

<script>
import Authentication from '@/mixins/Authentication';
import Forbidden from '@/views/default/Forbidden.vue';

export default {
	name: 'ProcessCreatePage',
	components: { Forbidden },
	mixins: [Authentication],
};
</script>
